<template>
  <v-list two-line subheader>


    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Image</v-list-item-title>
        <v-img class="mt-3" :src="doc.src"></v-img>
      </v-list-item-content>
    </v-list-item>

    <v-list-item>
      <v-list-item-content>
        <v-list-item-title>Title</v-list-item-title>
        <v-list-item-subtitle>{{ doc.title }}</v-list-item-subtitle>
      </v-list-item-content>
    </v-list-item>

  </v-list>
</template>

<script>
// @ is an alias to /src

export default {
  name: "AdminPlaneShow",
  data() {
    return {
      doc: {}
    };
  },
  created() {
    const ref = this.$parent.collection.doc(this.$route.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
      } else {
        alert("No such document!");
      }
    });
  },
  beforeRouteUpdate (to, from, next) {
    const ref = this.$parent.collection.doc(to.params.id);
    ref.get().then((doc) => {
      if (doc.exists) {
        this.doc = doc.data();
        next();
      } else {
        alert("No such document!");
      }
    });
  },
};
</script>
